import React from "react";
import styles from "./styles.module.scss";

export const Footer = () => {
  return (
    <footer className={styles.Footer}>
      <p>Vibecoded by Me in 20 Minutes 😁</p>
    </footer>
  );
}; 